import React, { PropTypes} from 'react';
import moment from "moment/moment";
import 'moment-timezone';

const timezone = 'America/New_York';

const DueDate = ({ className, due_date, format }) => {

    let past_due = moment(due_date) < moment();
    return (
        <div className={className}>
            Due Date:&nbsp;
            <span className={past_due ? 'late' : null}>
                {moment(due_date).tz(timezone).format(format)}
            </span>
        </div>
    );
};

DueDate.propTypes = {
    className: PropTypes.string,
    due_date: PropTypes.string.isRequired,
    format: PropTypes.string
};

DueDate.defaultProps = {
    format:  "ddd, MMM Do YYYY - h:mm:ss a"
};

export default  DueDate;


/** WEBPACK FOOTER **
 ** ./src/components/DueDate.js
 **/